import React from 'react';
import './Footer.css'; // Import a CSS file for styling
import { useNavigate } from 'react-router-dom';


const Footer = () => {

  const navigate = useNavigate();
  const handleNavigationServices = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById('services');
      if ( element ){
        element.scrollIntoView({behavior: 'smooth'});
      }
    }, 100);
  }

  const handleNavigationContact = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById('contact');
      if ( element ){
        element.scrollIntoView({behavior: 'smooth'});
      }
    }, 100);
  }

  const handleNavigationImpressum = () => {
    navigate('/impressum');
    setTimeout(() => {
      const element = document.getElementById('impressum');
      if ( element ){
        element.scrollIntoView({behavior: 'smooth'});
      }
    }, 100);
  }


  return (
    <footer className="footer">
      <div className="footer-links">
        {/*<Link to="/#services" className='footer-link' reloadDocument><a href="#services" className="footer-link">Dienstleistungen</a></Link>*/}
        <button className='btn-link' onClick={handleNavigationServices}>Dienstleistungen</button>
        <button className='btn-link' onClick={handleNavigationContact}>Kontakt</button>
        <button className='btn-link' onClick={handleNavigationImpressum}>Impressum</button>
        {/*<Link to="/#contact" className='footer-link' reloadDocument><a href="#contact" className="footer-link">Kontakt</a></Link>
        <Link to="/impressum" className='footer-link'><a href="" className="footer-link">Impressum</a></Link>*/}
      </div>
      <div className="footer-info">
        <p>© 2024 Delta Tank GmbH</p>
      </div>
    </footer>
  );
};

export default Footer;